import { FC, useEffect } from 'react';
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectBanner } from 'store/pages/pagesSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
import IQuiz from 'models/Quiz';
// Components
import Dialog from 'components/Dialog';
import AppBar from 'components/AppBar';
import PoweredBy from 'components/PoweredBy';
import SkipButton from 'components/SkipButton';

type Props = {
  onClose: () => void;
}

let timeout:any = null;

const BannerTextDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const banner = useAppSelector(selectBanner);
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  const timeoutTime = banner.timeout ? banner.timeout * 1000 : 2000;

  const navigateTo = useNavigateTo();

  useEffect(() => {
    if (previewPageMode) return;
    timeout = setTimeout(() => {
      onClose();
      navigateTo('pages-handler')
    }, timeoutTime);

    return () => {
      if ( timeout ) clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  const handleSkip = () => {
    if ( timeout ) clearTimeout(timeout);
    onClose();
    navigateTo('pages-handler');
  }

  return (
    <Dialog classes="p-4" background={quiz?.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : ''}>
      <AppBar />
      <div className="py-4 relative w-full h-full flex flex-col items-center justify-center gap-6">
        {banner.title ? (
          <h2 className="text-xl font-bold text-primary text-center">{banner.title}</h2>
        ) : null}
        <p className="text-md font-semibold text-primary text-center whitespace-pre-line">{banner.text}</p>
        {banner.timeout && banner.timeout > 3 ? (
          <SkipButton onSkip={handleSkip} />
        ) : null}
      </div>
      <PoweredBy />
    </Dialog>
  )
}

export default BannerTextDialog;
